import React, { useState, useEffect } from "react"
import { useHistory } from "react-router"
import BaseUrl from "../../../../config/BaseUrl"
import { postApi, getApi,  } from "../../../../config/Api/FakeuserApi";
import Swal from 'sweetalert2'
// import { Link, useHistory } from "react-router-dom";
import { getApiWithToken, PutApi, PostApi, DeleteApi } from "../../../../config/Api/FakeuserApi";
import background from "../SuperAdminLgin/background.png"


export default function SellerLogin(props) {
    const history = useHistory();
    const [Loader, setLoader] = useState(false)
    const [Email, SetEmail] = useState("")
    const [Password, SetPassword] = useState("")
    const [codeBtn, setcodeBtn] = useState(false);


      // CONFIRMATION CODE VALIDATION
      const [confirmationCode, setConfirmationcode] = useState("");
      const [confirmationCodeErr, setConfirmationcodeErr] = useState({});
      const [Ctrue, setCtrue] = useState(false);

      const Token = localStorage.getItem('SuperToken');




      useEffect(() => {

          alert("your emaiverificationcode is" + " " + props.location.state.code)

      }, [500])
      console.log("props",props)

      console.log("props code",props.location.state.code)
      console.log("props email",props.location.email)


  ////verify code api

  const VerifingCode = () => {

    setLoader(true);
    var formdata = new FormData();

    formdata.append("Email",props.location.email);
    formdata.append("Code", confirmationCode);


    PostApi(`${BaseUrl.Super_Admin_Url}/VerifyCode`, formdata, Token)
        .then(({ data }) => {
            setLoader(false);
            if (data.status) {
                console.log("if work")


                history.push({
                    pathname: "/SadminCPassword",
                         state: props.location.email
                    })
            }
            else if(data.message == "Code is expire"){

                setcodeBtn(true)

                Swal.fire({
                    title: "Opps",
                    text: data.message,
                    icon: "error"
                })

            }

            else {
                // $(".loader").hide();
                Swal.fire({
                    title: "Opps",
                    text: data.message,
                    icon: "error"
                })
            }




        }).catch(function (e) {
            // $(".loader").hide();
            Swal.fire({
                title: "Opps",
                text: e.message,
                icon: "error"
            })
        })



}



    const formValidationConf = () => {
        const confirmationCodeErr = {};

        let isValid = true;

        if (confirmationCode.trim().length === 0) {
            confirmationCodeErr.confirmationCodenull = "Enter Confirmation Code";
            isValid = false;
            setConfirmationcodeErr(confirmationCodeErr);
            setCtrue(false);
            return isValid;
        }



        else if (confirmationCode.length < 4) {
            // console.log("lrnth")

            confirmationCodeErr.confirmationCodenull = "Please enter maximum 4 digits otp code";
            isValid = false;

            setConfirmationcodeErr(confirmationCodeErr);
            setCtrue(false);
            return isValid;

        }

        else if (confirmationCode.length > 4) {


            confirmationCodeErr.confirmationCodenull = "Please enter maximum 4 digits otp code";
            isValid = false;

            setConfirmationcodeErr(confirmationCodeErr);
            setCtrue(false);
            return isValid;

        }





        // else if (confirmationCode == props.location.state.code) {
        //     confirmationCodeErr.confirmationCodenull = "success";
        //     history.push({
        //         pathname: "/SadminCPassword",
        //         state: props.location.email
        //     })

        //     isValid = true;
        //     setConfirmationcodeErr(confirmationCodeErr);
        //     setCtrue(true);
        //     return isValid

        // }


        // else if {

        //     confirmationCodeErr.confirmationCodenull = "Please enter correct OTP number";
        //     isValid = false;
        //     setConfirmationcodeErr(confirmationCodeErr);
        //     setCtrue(false);
        //     return isValid;
        // }

        else{
            VerifingCode()
        }




    }



    const SendVerificationCode = () => {

        setcodeBtn(false)

        setLoader(true);
        var formdata = new FormData();
        formdata.append("Email", props.location.email);

        PostApi(`${BaseUrl.Super_Admin_Url}/SendVerificationCode`, formdata)
            .then(({ data }) => {
                setLoader(false);
                if (data.status) {
                    console.log("verification code email Admin==>",data.code)
                    alert("your new emaiverificationcode is" + " " + data.code)

                } else {
                    // $(".loader").hide();
                    Swal.fire({
                        title: "Opps",
                        text: data.message,
                        icon: "error"
                    })
                }
            }).catch(function (e) {
                // $(".loader").hide();
                Swal.fire({
                    title: "Opps",
                    text: e.message,
                    icon: "error"
                })
            })



    }




    return (
        <>
            {Loader?<div className="loader" />:null}
            <div id="app" style={{backgroundImage: `url(${background})`, marginTop: '-50px', backgroundSize: 'cover', height: '100vh' }}>
                <section className="section">
                    <div className="container mt-5">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <img style={{ width: "25%" }} src="assets/louralogo/Loura-02.png"></img>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
                                <div className="card card-primary">
                                    <div className="card-header">
                                        <h4>Verify Code</h4>
                                    </div>
                                    <div className="card-body">
                                        <form method="" action="#" className="needs-validation" noValidate>
                                            <div className="form-group">
                                                <label htmlFor="email">OTP</label>
                                                <input  value={confirmationCode} onChange={(e)=>setConfirmationcode(e.target.value)}  id="email" type="number"  min="0" max="111111111111111111111" className="form-control" name="email" tabIndex={1} required autofocus />
                                                {Ctrue ?
                                                                            <div>
                                                                                {Object.keys(confirmationCodeErr).map((key) => {
                                                                                    return <div style={{ color: "green" }}>{confirmationCodeErr[key]}</div>
                                                                                })}
                                                                            </div>
                                                                            :
                                                                            <div>
                                                                                {Object.keys(confirmationCodeErr).map((key) => {
                                                                                    return <div style={{ color: "red" }}>{confirmationCodeErr[key]}</div>
                                                                                })}
                                                                            </div>
                                                                        }
                                            </div>




                                            <div className="form-group">
                                                <button  onClick={()=>formValidationConf()}  type="button" className="btn btn-primary btn-lg btn-block" tabIndex={4}>
                                                    Verify</button>
                                                    {codeBtn ? <a className="customPointer" onClick={()=>SendVerificationCode()} style={{marginLeft:"200px"}}>Resend Code</a>: ""}
                                            </div>
                                        </form>


                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}